<!-- Flex container wrapper -->
<div class="d-flex align-items-start custom-vertical-tabs my-2 gap-2">

  <!-- Navigation Left Sidebar -->
  <div class="nav flex-column nav-pills col-md-2" id="v-pills-tab" role="tablist" aria-orientation="vertical"
    style="width: 165px;">
    <button class="nav-link active" id="v-pills-tab1" data-bs-toggle="pill" data-bs-target="#tab1_content" type="button"
      role="tab" aria-controls="tab1_content" aria-selected="true">
      Institute Details
    </button>
    <button class="nav-link" id="v-pills-tab2" data-bs-toggle="pill" data-bs-target="#tab2_content" type="button"
      role="tab" aria-controls="tab2_content" aria-selected="false">
      Contacts
    </button>
    <button class="nav-link" id="v-pills-tab3" data-bs-toggle="pill" data-bs-target="#tab3_content" type="button"
      role="tab" aria-controls="tab3_content" aria-selected="false">
      Billing Details
    </button>
    <button class="nav-link" id="v-pills-tab5" data-bs-toggle="pill" data-bs-target="#tab5_content" type="button"
      role="tab" aria-controls="tab5_content" aria-selected="false" *ngIf="formData.institute.org_id != 'DEMO'">
      Package/Payment
    </button>
    <button class="nav-link" id="v-pills-tab6" data-bs-toggle="pill" data-bs-target="#tab6_content" type="button"
      role="tab" aria-controls="tab6_content" aria-selected="false">
      Terms & Cond.
    </button>

    <div *ngIf="reNewAlert && formData.institute.org_id != 'DEMO'" class="mt-5">
    <button class="btn btn-warning w-100 text-center" id="v-pills-tab7" data-bs-toggle="pill" data-bs-target="#tab7_content" type="button"
      role="tab" aria-controls="tab7_content" aria-selected="false">
      Select Package<br>to Re-New
    </button>
    </div>
  </div>

  <!-- Content Right Panel -->
  <div class="tab-content flex-grow-1 col-md-10" id="v-pills-tabContent">
    <div class="tab-pane fade show active p-2" id="tab1_content" role="tabpanel" aria-labelledby="tab1_content-tab"
      tabindex="0">
      <!-- <button class="btn btn-success putOnLeft" (click)="doUpdateInstitute()">
        <i class="bi bi-floppy2-fill"></i>&nbsp; Update Institute
      </button> -->

      <h4>Institute Details</h4>
      <div class="row g-3">
        <div class="col-3">
          <label class="form-label">Organization UUID</label>
          <!-- <input type="text" class="form-control" name="website" [(ngModel)]="formData.institute.org_id" disabled> -->
          <div class="form-control disabled-div" style="height: 38px;">{{formData.institute.org_id}}</div>
        </div>

        <div class="col-3">
          <label class="form-label">Institute Code</label>
          <!-- <input type="text" class="form-control" placeholder="Generated Institute ID" 
          aria-label="Institute ID" aria-describedby="button-addon2" readonly [(ngModel)]="formData.institute.inst_code"
            [disabled]="formData.institute.org_id == 'DEMO'"> -->
          <div class="form-control disabled-div" style="height: 38px;">{{formData.institute.inst_code}}</div>
        </div>
      </div>

      <div class="row g-3 mt-2">
        <div class="col-md-6">
          <label class="form-label">Institute Name</label>
          <!-- <input class="form-control" required name="inst_name" [(ngModel)]="formData.institute.inst_name"> -->
          <div class="form-control disabled-div" style="height: 38px;">{{formData.institute.inst_name}}</div>
        </div>
        <div class="col-md-3">
          <label class="form-label">Institute Type</label>
          <!-- <input class="form-control" required name="board" [(ngModel)]="formData.institute.inst_type"> -->
          <select class="form-select disabled-div" [(ngModel)]="formData.institute.inst_type" disabled>
            <option value="">Select</option>
            @for(it of dataService.institute_types; track $index;) {
            <option value="{{it.code}}">{{it.name}}</option>
            }
          </select>
        </div>
        <div class="col-md-3">
          <label class="form-label">Reg./Affiliation No.</label>
          <input type="text" class="form-control" required name="reg" [(ngModel)]="formData.institute.reg_no">
        </div>
      </div>

      <div class="row g-3 mt-2">
        <div class="col-md-5">
          <label class="form-label">Website</label>
          <input type="text" class="form-control" required name="website" [(ngModel)]="formData.institute.website"
            placeholder="http://">
        </div>
        <div class="col-md-4">
          <label class="form-label">GST No.</label>
          <input type="text" class="form-control" required name="gst" [(ngModel)]="formData.institute.gst_no">
        </div>
        <div class="col-md-3">
          <label class="form-label">Phone No</label>
          <input class="form-control" required name="phone_no" [(ngModel)]="formData.institute.phone_no">
        </div>
      </div>

      <div class="row g-4 mt-2">
        <div class="col-md-6">
          <label class="form-label">
            Logo Image
          </label>

          <div class="upload-box">
            <input class="form-control" type="file" accept="image/*" id="logo-file" 
              (change)="onLogoSelected($event)">
            <div class="preview-box mt-3 flex-column">
              <ng-container *ngIf="lImgPreview">
                <div style="width: 95%; text-align: end; margin-top: -10px;">
                  <i class="bi bi-x-circle-fill text-danger" style="cursor: pointer;" (click)="removeLogo()"></i>
                </div>
                <div style="width: 95%; height: 80px;" class="d-flex justify-content-center align-items-center">
                  <img [src]="lImgPreview" alt="Logo Preview" style="max-width: 90%; max-height: 90%; margin-top: -5px;" />
                </div>
              </ng-container>
              <span *ngIf="!lImgPreview">Logo Preview</span>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <label class="form-label">
            Banner Image
          </label>

          <div class="upload-box">
            <input class="form-control" type="file" accept="image/*" id="bnr-file" 
              (change)="onBnrSelected($event)">
            <div class="preview-box mt-3 flex-column">
              <ng-container *ngIf="bImgPreview">
                <div style="width: 95%; text-align: end; margin-top: -10px;">
                  <i class="bi bi-x-circle-fill text-danger" style="cursor: pointer;" (click)="removeBnr()"></i>
                </div>
                <div style="width: 95%; height: 80px;" class="d-flex justify-content-center align-items-center">
                  <img [src]="bImgPreview" alt="Logo Preview" style="max-width: 90%; max-height: 90%; margin-top: -5px;" />
                </div>
              </ng-container>
              <span *ngIf="!bImgPreview">Banner Preview</span>
            </div>
          </div>
        </div>
      </div>

      <div class="row g-3 mt-2">
        <div class="col-md-8">
          <label class="form-label">Address</label>
          <textarea class="form-control addressBox" rows="5" [(ngModel)]="formData.institute.address"
            style="height: 125px;"></textarea>
        </div>
        <div class="col-md-4">
          <label class="form-label">State/City/Pincode</label>
          <div class="mb-1">
            <!-- <label class="form-label">
                  State
              </label> -->
            <select class="form-select" [(ngModel)]="formData.institute.state"
              (change)="formData.institute.district = dataService.getDist(formData.institute.state)">
              <option>Select State</option>
              @for(st of dataService.cityDataDD; track $index) {
              <option>{{st.state}}</option>
              }
            </select>
          </div>
          <div class="mb-1">
            <!-- <label class="form-label">
                  City
              </label> -->
            <select class="form-select" [(ngModel)]="formData.institute.city">
              <option>Select City</option>
              <option *ngIf="formData.institute.city">{{formData.institute.city}}</option>
              @for(dist of formData.institute.district; track $index) {
              <option>{{dist}}</option>
              }
            </select>
          </div>
          <input type="tel" class="form-control mb-1" [(ngModel)]="formData.institute.pincode" placeholder="Pincode">
        </div>
      </div>

      <div class="my-3 text-end">
        <button class="btn btn-success" (click)="doUpdateInstitute()">Update Institute Details</button>
      </div>
    </div>

    <div class="tab-pane fade p-2" id="tab2_content" role="tabpanel" aria-labelledby="tab2_content-tab" tabindex="0">
      <!-- <button class="btn btn-success putOnLeft" (click)="doUpdateContacts()">
        <i class="bi bi-floppy2-fill"></i>&nbsp; Update Contacts
      </button> -->

      <h4>Contacts Details</h4>
      <div class="mb-2 mt-0 text-danger"><b>Note</b>: You must assign at least one contact as 'ERP Admin' to ensure new login details are received.</div>
      <div *ngFor="let contact of formData.contacts; let i=index" class="card mb-3 border">
        <div class="card-header d-flex align-items-center justify-content-between p-0 ps-3 mb-2">
          <strong> Contact {{i+1}}
          </strong>
          <button *ngIf="formData.contacts.length>1" class="btn btn-outline-danger btn-sm border-0 fw-bold px-3" (click)="removeContact(i)"> X </button>
        </div>
        <div class="card-body">
          <div class="row g-3">
            <div class="col-md-4">
              <input class="form-control" placeholder="Contact Name" [(ngModel)]="contact.person_name" name="name{{i}}">
            </div>
            <div class="col-md-4">
              <!-- <input class="form-control" placeholder="Designation" [(ngModel)]="contact.person_desi"
                name="designation{{i}}"> -->
              <select class="form-select" [(ngModel)]="contact.person_desi" name="designation{{i}}"
                [disabled]="['erp', 'chm', 'ppl', 'acc'].includes(contact.person_desi) && i<4">
                <option value="">Select Designation</option>
                @for(d of dataService.designations; track $index) {
                  <option value="{{d.code}}">{{d.name}}</option>
                }
              </select>
            </div>
            <div class="col-md-4">
              <!-- <input class="form-control" placeholder="Department" [(ngModel)]="contact.department"
                name="department{{i}}"> -->
              <select class="form-select" [(ngModel)]="contact.department" name="department{{i}}">
                <option value="">Select Department</option>
                @for(d of dataService.departments; track $index) {
                  <option value="{{d.code}}">{{d.name}}</option>
                }
              </select>
            </div>
            <div class="col-md-4">
              <input type="tel" class="form-control" placeholder="Mobile" [(ngModel)]="contact.mobile_no1" name="mobile{{i}}"
                maxlength="10">
            </div>
            <div class="col-md-4">
              <input type="tel" class="form-control" placeholder="Alternate Mobile" [(ngModel)]="contact.mobile_no2"
                name="altmobile{{i}}" maxlength="10">
            </div>
            <div class="col-md-4">
              <input type="email" class="form-control" placeholder="Email" [(ngModel)]="contact.email_id"
                name="email{{i}}">
            </div>
            <div class="col-12">
              <div class="form-check">
                <input type="checkbox" class="form-check-input" [checked]="contact.is_primary" (change)="setPrimary(i)">
                <label class="form-check-label"> Primary Contact </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-between align-items-center">
        <button class="btn btn-sm btn-outline-dark" (click)="addContact()"> Add Contact </button>
        <button class="btn btn-sm btn-success" (click)="doUpdateContacts()"> Update Contacts </button>
      </div>
    </div>

    <div class="tab-pane fade p-2" id="tab3_content" role="tabpanel" aria-labelledby="tab3_content-tab" tabindex="0">
      <!-- <button class="btn btn-success putOnLeft">
        <i class="bi bi-floppy2-fill"></i>&nbsp; Update Billing
      </button> -->

      <h4>Billing Details</h4>
      <div class="row g-3">
        <div class="col-md-6">
          <input type="text" class="form-control" placeholder="Billing Name" [(ngModel)]="formData.billing.billing_name">
        </div>
        <div class="col-md-3">
          <input type="text" class="form-control" placeholder="GST Number" [(ngModel)]="formData.billing.gst_no"
            [value]="formData.billing.gst_no">
        </div>
        <div class="col-md-3">
          <input type="text" class="form-control" placeholder="GST State Code" [(ngModel)]="formData.billing.gst_state_code">
        </div>
        <div class="row mx-0 px-0 g-3">
          <div class="col-md-8">
            <label class="form-label">Address</label>
            <textarea class="form-control addressBox" rows="5" style="height: 125px;" [(ngModel)]="formData.billing.address"></textarea>
          </div>
          <div class="col-md-4">
            <label class="form-label">State/City/Pincode</label>
            <div class="mb-1">
              <!-- <label class="form-label">
                    State
                </label> -->
              <select class="form-select" [(ngModel)]="formData.billing.state"
                (change)="formData.billing.district = dataService.getDist(formData.billing.state)">
                <option>Select State</option>
                @for(st of dataService.cityDataDD; track $index) {
                <option>{{st.state}}</option>
                }
              </select>
            </div>
            <div class="mb-1">
              <!-- <label class="form-label">
                    City
                </label> -->
              <select class="form-select" [(ngModel)]="formData.billing.city">
                <option>Select City</option>
                <option *ngIf="formData.billing.city">{{formData.billing.city}}</option>
                @for(dist of formData.billing.district; track $index) {
                <option>{{dist}}</option>
                }
              </select>
            </div>
            <input type="tel" class="form-control mb-1" [(ngModel)]="formData.billing.pincode" placeholder="Pincode">
          </div>
        </div>

        <div class="my-3 text-end">
          <button class="btn btn-success" (click)="doUpdateBilling()">Update Billing Details</button>
        </div>

      </div>
    </div>

    <div class="tab-pane fade p-2" id="tab5_content" role="tabpanel" aria-labelledby="tab5_content" tabindex="0">
      <h4>Package Details</h4>
      <div>
        <!-- Expiring Message -->
        <div class="topbar-center blink-text text-center text-danger" *ngIf="reNewAlert">
          <i class="bi bi-hourglass-split"></i>
          Your subscription ends on [{{user.exp_date|date}}]. Re-new it soon to keep your services running.
          <!-- <a [routerLink]="['/dashboard/', dataService.myEncrypt('kyc')]">Re-New!</a> -->
        </div>

        <div class="row g-3">
          <!-- Statistics -->
          <div class="row g-3 mb-4">
            <div class="col-lg-3 col-md-6">
              <div class="card stat-card bg-info text-dark bg-opacity-10">
                <div class="card-body text-center">
                  <small>Current Plan</small>
                  <h5 class="m-0">{{getPackName()}}</h5>
                </div>
              </div>

              <div class="popover bs-popover-auto fade show mt-2" role="tooltip" id="popover830604" 
                style="position: absolute; max-width: 75.5%;" data-popper-placement="bottom">
                <div class="popover-arrow" style="position: absolute; left: 0px; transform: translate(59px, 0px);"></div>
                <div class="popover-body p-2"><b>Modules</b>: {{formData.package.selected_modules.join(', ')}}</div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6">
              <div class="card stat-card bg-secondary text-dark bg-opacity-10">
                <div class="card-body text-center">
                  <small>Billing Cycle</small>
                  <h5 class="m-0">{{formData.package.bill_cycle}}</h5>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6">
              <div class="card stat-card bg-warning text-dark bg-opacity-10">
                <div class="card-body text-center">
                  <small>Students</small>
                  <h5 class="m-0">{{formData.package.std_counts}}</h5>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6">
              <div class="card stat-card bg-success text-dark bg-opacity-10">
                <div class="card-body text-center">
                  <small>Package Amount</small>
                  <h5 class="m-0">₹ {{formData.package.total_amount}}/-</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <h4 class="mt-5">Payment Verification</h4>
      <p>At subscription or KYC details time, user has pay the package amount via online or offline. Admin has to verify
        the received payment to complete the subscription.</p>
      <!-- <p>Institute had pay Online/Offline amount Rs. 0.00/- on dated 22-06-2026</p> -->
      <!-- Pricing Summary -->
      <div class="pricing-summary col-lg-12">
        <div class="card shadow-sm">
          <div class="card-header" style="padding: 5px 15px !important;">
            Order Summary
          </div>
          <div class="card-body" *ngIf="formData.package && formData.package.pkg_code">
            <div class="row d-flex justify-content-between">
              <div class="col-5" style="line-height: 35px;">
                <div class="summary-row">
                  <span>Package / Plan:</span> <span>{{ getPackName() }}</span>
                </div>
                <div class="summary-row">
                  <span>Custom Modules:</span> <span>{{ formData.package.selected_modules.length || 'Default' }}</span>
                </div>
                <div class="summary-row">
                  <span>Billing Cycle:</span> <span>{{ formData.package.bill_cycle }}</span>
                </div>
                <div class="summary-row">
                  <span>Students:</span> <span>{{ formData.package.std_counts | number }}</span>
                </div>
              </div>
              <!-- <div class="summary-divider"></div> -->
              <div class="col-5" style="line-height: 35px;">
                <div class="summary-row">
                  <span>Base Amount</span>
                  <span>₹ {{ $any(formData.package).base_amount }}/-</span>
                </div>
                <!-- @if (pricing.discountAmount >= 0) { -->
                <div class="summary-row discount">
                  <span>Discount (-)</span>
                  <span>₹ {{ $any(formData.package).discount_amount || 0 }}/-</span>
                </div>
                <!-- } -->
                <div class="summary-row">
                  <span>Subtotal</span>
                  <span>₹ {{ $any(formData.package).net_amount }}/-</span>
                </div>
                <div class="summary-row">
                  <span>GST (18%)</span>
                  <span>₹ {{ $any(formData.package).tax_amount }}/-</span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="summary-divider col-12"></div>
              <div class="summary-row total col-12 px-3">
                <span>Total Amount (Paid {{$any(formData.package).paid_offline ? 'Offline' : 'Online'}})</span>
                <span>₹ {{ $any(formData.package).total_amount }}/-</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex align-items-center justify-content-center my-2 mb-3 flex-column">       
        <div class="row col-12">
          <div class="col-6">
            <label class="form-label">License key:</label>
            <!-- <input type="text" class="form-control" placeholder="Generated License Key" aria-label="License Key" 
              aria-describedby="button-addon2" readonly [(ngModel)]="formData.institute.agr_lickey"> -->
            <div class="form-control disabled-div" style="height: 38px;">{{formData.institute.agr_lickey}}</div>
          </div>
          <div class="col-3">
            <label class="form-label">Start Date: </label>
            <!-- <input type="date" class="form-control" [(ngModel)]="formData.package.start_date"> -->
            <div class="form-control disabled-div" style="height: 38px;">{{dataService.ymd2dmy(formData.package.start_date)}}</div>
          </div>
          <div class="col-3">
            <label class="form-label">Expiry Date: </label>
            <!-- <input type="date" class="form-control" [(ngModel)]="formData.package.exp_date"> -->
            <div class="form-control disabled-div" style="height: 38px;">{{dataService.ymd2dmy(formData.package.exp_date)}}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="tab-pane fade p-2" id="tab6_content" role="tabpanel" aria-labelledby="tab6_content-tab" tabindex="0">
      <div class="row g-4 px-3">
        <div class="form-card">
          <h2 align="center">Terms and Conditions</h2>
          <p align="center" class="section-desc">Please read and accept our terms and conditions</p>

          <div class="terms-content">
            <div class="terms-box">
              <h4>Service Agreement</h4>
              <p>By subscribing to Macwill ERP, you agree to the following terms:</p>
              <ul>
                <li>The subscription is valid for the selected billing cycle from the date of payment confirmation.
                </li>
                <li>The number of students is limited to the quantity selected during purchase.</li>
                <li>Data backup is provided according to your selected plan.</li>
                <li>The service can be renewed before expiry to ensure uninterrupted access.</li>
                <li>All prices are inclusive of applicable taxes.</li>
                <li>Macwill reserves the right to suspend services for non-payment or policy violations.</li>
                <li>Refunds are processed within 7-10 business days subject to approval.</li>
              </ul>
              <p>For complete terms, please refer to the Service Level Agreement document.</p>
            </div>
          </div>
          <div class="signature-section">
            <h5>Authorization Signature</h5>
            <div class="row">
              <div class="col-12 my-2">
                <label for="consent">
                  <i class="bi bi-file-earmark-check text-success" *ngIf="formData.agreement.consent"></i>
                  <i class="bi bi-file-earmark-excel text-danger" *ngIf="!formData.agreement.consent"></i>
                  Yes, I read and accept the terms and conditions.
                </label>
              </div>
              <div class="col-md-6">
                <label>Name:</label>&nbsp;&nbsp; <b>{{formData.agreement.name}}</b>
              </div>
              <div class="col-md-6">
                <label>Designation:</label>&nbsp;&nbsp; <b>{{dataService.getDesiName(formData.agreement.designation)}}</b>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="tab-pane fade p-2" id="tab7_content" role="tabpanel" aria-labelledby="tab7_content-tab" tabindex="0">
        <h2>Select Your Plan</h2>
        <p class="section-desc">Choose modules and configure your subscription</p>

        <div class="modules-select mb-3">
          <div class="modules-grid-large">
            @for (module of modules; track module.id) {
            <label class="module-card" [class.selected]="selectedModules.includes(module.code)">
              <input type="checkbox" [checked]="selectedModules.includes(module.code)"
                (change)="toggleModule(module.code); updatePackagePrice();" />
              <div class="module-info">
                <strong class="module-title">{{ module.m_name }}</strong>
                <div class="module-desc">{{ module.description }}</div>
                <div class="module-prices">
                  <span>Monthly: Rs. {{ module.m_price }}/student</span>
                  <span>Quarterly: Rs. {{ module.q_price }}/student</span>
                  <span>Semi Annually: Rs. {{ module.h_price }}/student</span>
                  <span>Annually: Rs. {{ module.a_price }}/student</span>
                </div>
              </div>
            </label>
            }
          </div>
        </div>


      <div class="row g-3">
        <div class="col-md-3">Billing Cycle:
          <select class="form-select" [(ngModel)]="formData.package.bill_cycle" name="subscription"
            (change)="calculateExpiry(); updatePackagePrice();">
            <option>Monthly</option>
            <option>Quarterly</option>
            <option>Semi Annually</option>
            <option>Annually</option>
          </select>
        </div>
        <div class="col-md-2">Std. Counts:
          <input type="number" class="form-control" placeholder="Std. Limit"
            [(ngModel)]="formData.package.std_counts" name="studentsLimit"
            (ngModelChange)="updatePackagePrice();">
        </div>
        <div class="col-md-3">
          <!-- Base Amount:
          <input type="number" class="form-control" placeholder="Amount" 
            [(ngModel)]="formData.package.base_amount" name="amount" readonly> -->
        </div>

        <div class="col-md-4 d-flex align-items-center flex-column">
          Payment Method:
          <div class="btn-group btn-group-sm" role="group" aria-label="Basic radio toggle button group"
            (click)="updatePackagePrice();">
            <input type="radio" class="btn-check" name="btnradio" id="btnradio1" [value]="true" 
              [(ngModel)]="formData.package.paid_offline" checked>
            <label class="btn btn-outline-secondary" for="btnradio1">I will pay Offline</label>

            <input type="radio" class="btn-check" name="btnradio" id="btnradio2" [value]="false" 
              [(ngModel)]="formData.package.paid_offline">
            <label class="btn btn-outline-secondary" for="btnradio2">I will pay Online</label>
          </div>

        </div>

      </div>

        <!-- Pricing Summary -->
        <div class="pricing-summary col-lg-12">
          <div class="card shadow-sm">
            <div class="card-header" style="padding: 5px 15px !important;">
              Order Summary
            </div>

            <div class="card-body">
            <div class="row d-flex justify-content-between">
              <div class="col-5" style="line-height: 35px;">
                <div class="summary-row">
                  <span>Package / Plan:</span> <span>{{ getPackName() }}</span>
                </div>
                <div class="summary-row">
                  <span>Custom Modules:</span> <span>{{ formData.package.selected_modules.length || 'Default' }}</span>
                </div>
                <div class="summary-row">
                  <span>Billing Cycle:</span> <span>{{ formData.package.bill_cycle }}</span>
                </div>
                <div class="summary-row">
                  <span>Students:</span> <span>{{ formData.package.std_counts | number }}</span>
                </div>
              </div>
              <!-- <div class="summary-divider"></div> -->
              <div class="col-5" style="line-height: 35px;">
                <div class="summary-row">
                  <span>Base Amount</span>
                  <span>₹ {{ $any(formData.package).base_amount }}/-</span>
                </div>
                <div class="summary-row discount">
                  <span>Modules Amount</span>
                  <span>+{{ formData.package.module_amount }}/-</span>
                </div>
                <!-- @if (pricing.discountAmount >= 0) {
                <div class="summary-row discount">
                  <span>Discount (-)</span>
                  <span>₹ {{ $any(formData.package).discount_amount || 0 }}/-</span>
                </div>
                } -->
                <div class="summary-row">
                  <span>Subtotal</span>
                  <span>₹ {{ $any(formData.package).net_amount }}/-</span>
                </div>
                <div class="summary-row">
                  <span>GST (18%)</span>
                  <span>₹ {{ $any(formData.package).tax_amount }}/-</span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="summary-divider col-12"></div>
              <div class="summary-row total col-12 px-3">
                <span>Total Amount (Paid {{$any(formData.package).paid_offline ? 'Offline' : 'Online'}})</span>
                <span>₹ {{ $any(formData.package).total_amount }}/-</span>
              </div>
            </div>

            </div>
          </div>
        </div>

        <div class="my-3 text-end">
          <button class="btn btn-success" (click)="pkgSubscribe()">Submit Package Request!</button>
        </div>


      <div class="card card-body smsg text-center" *ngIf="reNewSubmit">
        <i class="bi bi-check-circle-fill text-success fs-1"></i>

        <h2>Request Submitted Successfully!</h2>
        <p class="mx-5">
          Our verification team will review your details.
          After payment verification, you will get notify via email and text message.
        </p>

        <p align="center" *ngIf="formData.package.paid_offline">
          <button class="btn btn-sm btn-outline-secondary" data-bs-dismiss="modal">Close Me</button>
        </p>

        <p align="center" *ngIf="!formData.package.paid_offline">
          <button class="btn btn-sm btn-primary" (click)="paymentClick()" data-bs-dismiss="modal">Proceed to Payment!</button>
        </p>

      </div>
    </div>

  </div>
</div>
